import { Component, OnInit, EventEmitter, NgModule, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core'
import { FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { User } from '@model/user/user'
import { UserService } from '@service/user/user.service'
import { modelToFormGroup } from 'aautil'
import { Contactperson } from '@model/contactperson'
import { messages } from '@configuration/messages';
import { ConfirmDialogComponent } from '@modal/confirm-dialog/confirm-dialog.component'
import { MatDialog } from '@angular/material/dialog';
import { tinyDefaultConfig } from '@configuration/tiny-default-config';
import { standardvalidators } from '@configuration/standard-validators';
import { countries } from '@configuration/countries';
import { CompanyProfile } from '@model/company-profile/company-profile';
import { LoadingService } from '@service/loading.service';
import { ImageKeys } from '@type/image-keys';
import { StateService } from '@service/state.service';
import { TypeService } from '@service/type.service';
import { AboutBlockHeaderComponentModule } from '../about-block-header/about-block-header.component';
import { ProfileHeaderComponentModule } from '../profile-header/profile-header.component';
import { BlogCardComponentModule } from '@component/generic/cards/blog-card/blog-card.component';
import { JobCardComponentModule } from '@component/generic/cards/job-card/job-card.component';
import { AdvertGridItemModule } from '@component/shared/advert-grid-item/advert-grid-item.component';
import { ImageUploadBoxComponentModule } from '@component/generic/image-upload-box/image-upload-box.component';
import { EditImagesComponentModule } from '@component/generic/edit-images/edit-images.component';
import { EditorModule } from '@tinymce/tinymce-angular';

@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.scss'],
})
export class CompanyProfileComponent implements OnInit {

  public countries = countries

  public tinyDefaultConfig = tinyDefaultConfig

  public messages = messages

  public tabs = {

    'info': {
      name: 'Info',
      edit: false,
      selected: false,
      attributes: [
        'information_products',
        'information_year_of_founding',
        'information_about_us',
        'information_news',
      ],
      hidden: false
    },

    'posts': {
      name: 'Neuste Beiträge',
      selected: false,
      filled: false,
      edit: false,
      hidden: false,
    },

    'references': {
      name: 'Leistungen/Referenzen',
      edit: false,
      selected: false,
      attributes: ['service_products'],
      hidden: false
    },

    'contactpersons': {
      name: 'Ansprechpartner',
      edit: false,
      selected: false,
      attributes: ['contactpersons'],
      hidden: false
    },

    'contact': {
      name: 'Kontakt',
      edit: false,
      selected: false,
      attributes: [
        'name',
        'telephone',
        'email',
        'website',
        'street',
        'street_additional',
        'zip',
        'city',
        'state',
        'country',
        'impressum',
        'information_opening_hours',
        'contact_name',
        'contact_position',
      ],
    },

    'socialmedia': {
      name: 'Socialmedia',
      edit: false,
      selected: false,
      attributes: ['facebook', 'instagram', 'linkedin', 'xing', 'youtube', 'twitter'],
      hidden: false
    },
  }

  public tabKeys = Object.keys(this.tabs)

  public user: User
  public form: FormGroup

  public socialmedia = {
    'facebook': {
      name: 'Facebook',
      icon: 'fab fa-facebook-square'
    },
    'instagram': {
      name: 'Instagram',
      icon: 'fab fa-instagram'
    },
    'linkedin': {
      name: 'LinkedIn',
      icon: 'fab fa-linkedin'
    },
    'xing': {
      name: 'Xing',
      icon: 'fab fa-xing-square'
    },
    'youtube': {
      name: 'Youtube',
      icon: 'fab fa-youtube'
    },
    'twitter': {
      name: 'Twitter',
      icon: 'fab fa-twitter-square'
    },
  }

  public socialmediakeys = Object.keys(this.socialmedia)

  public submitted: boolean = false

  public switchTab: EventEmitter<void> = new EventEmitter()

  public displayStructure = null
  public _companyProfile = null;

  set companyProfile(cp: CompanyProfile) {
    this._companyProfile = cp

    this.displayStructure = this.companyProfile.transformToDisplayStructure()

    this.tabKeys = this.reorderTabs();
    if(!Object.values(this.tabs).some(tab => tab.selected)){
      this.openFirstFilledTab()
    }
  }

  get companyProfile() {
    return this._companyProfile
  }

  constructor(
    public userService: UserService,
    private dialog: MatDialog,
    private LoadingService: LoadingService,
    private StateService: StateService,
    private typeService: TypeService
  ) {
    this.userService.userObservable.subscribe(user => {
      this.user = user

      if (this.user && this.user.company_profile) {
        this.form = modelToFormGroup(this.user.company_profile)

        this.LoadingService.startLoad();

        this.userService.getCompanyProfileById(this.user.company_profile.id)
          .then((cp: CompanyProfile) => {
            this.companyProfile = cp
          })
          .finally(() => {
            this.LoadingService.stopLoad();
          })
      }
    })
  }

  public ngOnInit() {
    if (!this.user) {
      const user = this.userService.user

      if (user) {
        this.user = user
        this.form = modelToFormGroup(this.user.company_profile)
      }
    }

  }

  public saveContactpersons(): Promise<void> {
    return new Promise((resolve, reject) => {

      this.LoadingService.startLoad()
      let arr: Contactperson[] = []
      for (let c of this.form.controls["contactpersons"].value) {
        arr.push(Object.assign(new Contactperson(), c))
      }
      let updateObject: any = { contactpersons: arr }
      this.userService.updateCompanyProfile(updateObject)
        .catch(() => reject())
        .then(() => resolve())
        .finally(() => {
          this.LoadingService.stopLoad()
        })

    })
  }

  public save(atts: string[] = []): Promise<void> {

    return new Promise((resolve, reject) => {

      if (this.user && this.user.company_profile) {

        this.LoadingService.startLoad()

        let updateObject: CompanyProfile = new CompanyProfile()
        for (const att of atts) {
          updateObject[att] = this.form.controls[att].value
          // this.user.company_profile[att] = this.form.controls[att].value
        }

        this.userService.updateCompanyProfile(updateObject)
          .then(() => { resolve() })
          .catch(() => { reject() })
          .finally(() => {
            this.LoadingService.stopLoad()
          })
      }
      else {
        reject()
      }

    })
  }

  public cancel(): void {

    for (let key of this.tabKeys) {
      this.tabs[key].edit = false
    }

    if (this.user && this.user.company_profile) {
      this.form = modelToFormGroup(this.user.company_profile)
    }
  }

  private showDiscardEditDialog() {
    return new Promise((resolve, reject) => {

      const confirmConfig = {
        text: 'Du bearbeitest gerade die Informationen auf der aktuellen Seite. Willst Du deine Änderungen verwerfen?',
        buttons: [
          {
            text: 'Nein',
            value: 'abort',
          },
          {
            text: 'Ja',
            value: 'throw',
          },
        ],
      }
      this.LoadingService.stopLoad()
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: confirmConfig,
        disableClose: true,
        panelClass: ConfirmDialogComponent.cssClass
      })
      dialogRef.afterClosed().subscribe(result => {
        resolve(result)
      })

    })
  }

  private selectNavItem(tabKey: string) {
    // cancel all active edits
    this.cancel()

    // deselect previous tab
    for (let t of this.tabKeys) {
      this.tabs[t].selected = false
    }

    this.tabs[tabKey].selected = true
  }

  public clickNavItem(tabKey: string) {

    // find current
    let tabindex
    for (let key of this.tabKeys) {
      if (this.tabs[key].selected) {
        tabindex = key
        break
      }
    }

    // if user edits current tab - ask him if he wants to discard or abort
    if (this.tabs[tabindex].edit) {
      this.showDiscardEditDialog()
        .then((response => {
          if (response == 'abort')
            return
          else {
            this.switchTab.emit()
            this.selectNavItem(tabKey)
          }
        }))
    }
    else {
      this.selectNavItem(tabKey)
    }
  }

  public fileSelected(event: any, purpose: any): void {
    if (event.target.files && event.target.files[0]) {
      this.fileDropped(event.target.files, purpose)
    }
  }

  public fileDropped(filelist: any, purpose: ImageKeys) {

    this.LoadingService.startLoad()
    this.userService.onDropFile(
      filelist,
      purpose,
      this.user.company_profile.id,
      true
    )
      .then((response: User) => {
        this.user.company_profile.certifacteImages = response.company_profile.certifacteImages
        this.user.company_profile.productImages = response.company_profile.productImages
      })
      .finally(() => {
        this.LoadingService.stopLoad()
      })

  }

  public deleteImage(imageId: number, key: ImageKeys): Promise<void> {
    return new Promise((resolve, reject) => {

      this.LoadingService.startLoad()

      this.userService.deleteCompanyProfileImage(imageId)
        .then((user: User) => {
          this.user.company_profile.certifacteImages = user.company_profile.certifacteImages
          this.user.company_profile.productImages = user.company_profile.productImages
          resolve()
        })
        .catch(err => {
          console.error(err)
          reject(err)
        })
        .finally(() => {
          this.LoadingService.stopLoad()
        })
    })
  }

  public addContactPerson() {
    let formarray: FormArray = <FormArray>this.form.controls["contactpersons"]

    let newFormGroup = new FormGroup({
      area: new FormControl(''),
      firstname: new FormControl(''),
      lastname: new FormControl(''),
      tel: new FormControl('', standardvalidators.tel),
      email: new FormControl('', [Validators.email]),
    })

    // add it to form
    formarray.push(newFormGroup)
  }

  public removeContactPerson(index: number) {
    let formarray: FormArray = <FormArray>this.form.controls["contactpersons"]
    formarray.removeAt(index)
  }

  public onAutocompleteSelected($event: any) {

    if (!$event.address_components)
      return

    for (const cityDef of $event.address_components) {
      if (cityDef.types.includes('locality')) {
        this.form.controls.city.setValue(cityDef.long_name)
      }
      if (cityDef.types.includes('postal_code')) {
        this.form.controls.zip.setValue(cityDef.long_name)
      }
    }
  }

  public somethingIsBeingEdited(): boolean {
    for (let key of this.tabKeys)
      if (this.tabs[key].edit)
        return true
    return false
  }

  public preview() {
    this.StateService.goto(
      '/businessprofileexternal/' + this.user.company_profile.id
    )
  }

  private openFirstFilledTab() {
    // iterate through ordered tabKeys instead of a new displayStructure
    for (let tabKey of this.tabKeys) {
      if (this.typeService.profileObjectFilled(this.displayStructure[tabKey])) {
        this.selectNavItem(tabKey);
        return;
      }
    }
  }

  private reorderTabs(): string[] {
    const keys = Object.keys(this.tabs);
    const hasPosts = this.displayStructure && this.displayStructure['posts'] && this.displayStructure['posts'].length > 0;

    if (hasPosts) {
      return ['posts', ...keys.filter(key => key !== 'posts')];
    }

    this.tabs['posts'].hidden = true;

    return keys;
  }
}

@NgModule({
  declarations: [
    CompanyProfileComponent,
  ],
  imports: [
    AboutBlockHeaderComponentModule,
    ProfileHeaderComponentModule,
    BlogCardComponentModule,
    AdvertGridItemModule,
    JobCardComponentModule,
    ImageUploadBoxComponentModule,
    EditImagesComponentModule,
    EditorModule
  ],
  exports: [
    CompanyProfileComponent,
  ]
})
export class CompanyProfileComponentModule { }